// removed by extract-text-webpack-plugin
module.exports = {"container":"app-pages-Customers-CustomerList-ListNonLoyalty-ActionBar-LoyaltyBanner-__LoyaltyBanner___3Q9KN","banner":"app-pages-Customers-CustomerList-ListNonLoyalty-ActionBar-LoyaltyBanner-__LoyaltyBanner___G6TdU"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Customers/CustomerList/ListNonLoyalty/ActionBar/LoyaltyBanner/LoyaltyBanner.css
// module id = 2301
// module chunks = 0